import { ComposeRawMessageForm } from '../components/ComposeRawMessageForm';

export function ComposeRawMessagePage() {
  return <ComposeRawMessageForm />;
}
